<template>
  <div class="our-team">
    <h2>
      {{ title }}
    </h2>
    <div class="our-team-items">
      <OurTeamCard
        v-for="(item, key) in team"
        :key="key"
        :result="item"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { useTeam } from "../../composables/useTeam";

export default {
  name: "OurTeam",
  props: {
    params: {
      type: Object,
      default: {},
    }
  },
  computed: {
    ...mapState({
      title: ({ subHeader }) => subHeader.data.title,
    }),
  },
  setup(props) {
    const team =props.params.team;

    return {
      team,
    }
  }
}
</script>


<style lang="scss" scoped>
.our-team {
  margin: 80px 0 161px;
  @include tablet {
    margin: 60px 0;
  }
}
.our-team-items{
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: 68px 30px;
  @include tablet{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  @include mobile{
    grid-gap: 30px 15px;
  }
}
</style>